import { hotTopics } from '@/mocks/gossip';

const topColors = [
  'bg-primary-500 text-background-50',
  'bg-primary-400 text-background-50',
  'bg-accent-500 text-background-50',
];

export default function HotRank() {
  return (
    <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100/70">
      <div className="flex items-center justify-between border-b border-background-200 bg-gradient-to-r from-primary-500 to-primary-600 px-5 py-4">
        <div className="flex items-center gap-2 text-background-50">
          <i className="text-lg ri-fire-fill" />
          <h3 className="font-heading text-lg font-bold">热搜榜 · 实时</h3>
        </div>
        <span className="text-xs text-background-200">每 5 分钟更新</span>
      </div>
      <ul className="divide-y divide-background-200 p-2">
        {hotTopics.map((t, i) => (
          <li key={t.rank} className="group flex items-center gap-3 px-3 py-2.5 hover:bg-background-50">
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                topColors[i] || 'bg-background-200 text-foreground-500'
              }`}
            >
              {t.rank}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                {t.title}
              </p>
              <p className="mt-0.5 text-xs text-foreground-500">热度 {t.heat} 万</p>
            </div>
            <i className="text-base text-foreground-300 transition-all group-hover:-translate-x-0.5 group-hover:text-primary-400 ri-arrow-right-up-line" />
          </li>
        ))}
      </ul>
    </div>
  );
}